export class UpdatePurchasingGroupSettingsCommand {
    constructor(
        public readonly required: boolean,
        public readonly showDuringOrderingProcess: boolean,
        public readonly defaultPurchasingGroupId: string | null,
    ) {}
}
